// This is the entry point for reCAPTCHA v2 JS. Add JavaScript imports here.
import './recaptcha';
